import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchMerchandiseCategoriesSorted } from "../../../../../redux/actions/catalog/catalog";
import { useAppSelector } from "../../../../../redux/hooks";
import { mapIDescriptionToDropDownOptions } from "../../../../../utils";
import { CustomSelector, ISelectorProps } from "../../customSelector/customSelector";

export const CustomMerchandiseCategoryIdSelector: React.FC<ISelectorProps> = ({ onChange, selectedKey, name, title, disabled }) => {
    const dispatch = useDispatch();

    const { data, loading } = useAppSelector((store) => store.catalog.merchandiseCategoriesSorted);

    useEffect(() => {
        !data.length && !loading && dispatch(fetchMerchandiseCategoriesSorted());
    }, []);
    return (
        <CustomSelector
            title={title}
            options={mapIDescriptionToDropDownOptions(data)}
            onChange={onChange}
            selectedKey={selectedKey}
            name={name}
            disabled={disabled}
        ></CustomSelector>
    );
};
